import React from "react";
import { Navigate } from "react-router-dom";

import Home from "../pages/Home";
import ProductDetailRoute from "../features/detail/ProductDetailRoute";
import SupplierProfileRoute from "../features/detail/SupplierProfileRoute";
import SupplierProductDetailRoute from "../features/detail/SupplierProductDetailRoute";
import SupplierProductsPage from "../pages/SupplierProducts";
import Finance from "../pages/Finance";
import FinanceTransactions from "../pages/FinanceTransactions";
import FinanceWithdraw from "../pages/FinanceWithdraw";
import FinanceWithdrawals from "../pages/FinanceWithdrawals";
import FinanceWithdrawalDetail from "../pages/FinanceWithdrawalDetail";
import FinanceTopUpReturn from "../pages/FinanceTopUpReturn";
import ShoppingCartPage from "../pages/ShoppingCart";
import CheckoutPage from "../pages/Checkout";
import AccountSettings from "../pages/AccountSettings";


import Info from "../containers/Profile/Info";
import ShoppingCartSummaryPage from "../pages/ShoppingCartSummary";
import OrderPaymentPage from "../pages/OrderPayment";
import DeleteUser from "../containers/AccountSettings/Settings/DeleteUser";
import Orders from "../pages/Orders";
import SavedAccounts from "../pages/SavedAccounts";
import OrderDetail from "../containers/Order/ConsumerOrders/OrderDetail";
import MyReviews from "../pages/MyReviews";
import SavedSuppliers from "../pages/SavedSuppliers";
import Faqs from "../pages/Faqs";
import SupplierReviewList from "../pages/SupplierReviewList";
import ProductsSearchPage from "../pages/ProductsSearch";
import AccessoriesPage from "../pages/Accessories";
import AccessoryDetailRoute from "../features/accessories/AccessoryDetailRoute";

import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";
import GetStarted from "../features/auth/screens/GetStarted";
import VerificationRoute from "../features/auth/screens/Verification/Route";
import AuthSignUp from "../features/auth/screens/SignUp";
import AddPhoto from "../features/auth/screens/AddPhoto";
import AuthStep from "../features/auth/AuthGuard";

export const routes = [
  {
    key: "home",
    path: "/",
    component: <Home />,
  },

  // The password flow is gone. Anything still pointing at /login — a
  // bookmark, an old email, a stale tab — lands on the phone/email start.
  {
    key: "terms",
    path: "/terms",
    component: <Terms />,
  },
  {
    key: "privacy",
    path: "/privacy",
    component: <Privacy />,
  },
  {
    key: "legacy-login",
    path: "/login",
    component: <Navigate to="/auth" replace />,
  },
  {
    key: "legacy-profile",
    path: "/profile/info",
    component: <Navigate to="/account-settings" replace />,
  },
  {
    key: "profile",
    path: "/profile/:information",
    component: <Info />,
  },
  {
    key: "product-detail-resolve",
    path: "/products",
    component: <ProductDetailRoute />,
  },
  {
    key: "product-detail",
    path: "/products/:productId",
    component: <ProductDetailRoute />,
  },
  {
    key: "supplier-profile",
    path: "/suppliers/:supplierId",
    component: <SupplierProfileRoute />,
  },
  {
    key: "supplier-product-detail",
    path: "/suppliers/:supplierId/products/:productId",
    component: <SupplierProductDetailRoute />,
  },
  {
    key: "supplier-reviews-list",
    path: `/supplier/detail/reviews-list/:id`,
    component: <SupplierReviewList />,
  },
  {
    key: "supplier-products",
    path: "/supplier/detail/:supplierId/products/:fuelTypeId/:containerOptionId/:containerMaterialId",
    component: <SupplierProductsPage />,
  },
  {
    key: "accessories",
    path: "/accessories",
    component: <AccessoriesPage />,
  },
  {
    key: "accessory-detail",
    path: "/accessories/:productId",
    component: <AccessoryDetailRoute />,
  },
  {
    key: "product-search",
    path: "/supplier/products/:containerOptionId/:containerMaterialId",
    component: <ProductsSearchPage />,
  },
  {
    key: "my-orders",
    path: "/my-orders",
    component: <Orders />,
  },
  {
    key: "my-orders-detail",
    path: "/my-orders/detail",
    component: <OrderDetail />,
  },
  {
    key: "shopping-cart",
    path: "/my-cart",
    component: <ShoppingCartPage />,
  },
  {
    key: "shopping-cart-summary",
    path: "/my-cart/summary",
    component: <ShoppingCartSummaryPage />,
  },
  {
    key: "checkout",
    path: "/checkout",
    component: <CheckoutPage />,
  },
  {
    key: "checkout-return",
    path: "/checkout/return",
    component: <CheckoutPage />,
  },
  {
    key: "payment-page",
    path: "/order/payment",
    component: <OrderPaymentPage />,
  },

  {
    key: "finance",
    path: "/finance",
    component: <Finance />,
  },
  {
    key: "finance-transactions",
    path: "/finance/transactions",
    component: <FinanceTransactions />,
  },
  {
    key: "finance-withdraw",
    path: "/finance/withdraw",
    component: <FinanceWithdraw />,
  },
  {
    key: "finance-withdrawals",
    path: "/finance/withdrawals",
    component: <FinanceWithdrawals />,
  },
  {
    key: "finance-withdrawal-detail",
    path: "/finance/withdrawals/:payoutId",
    component: <FinanceWithdrawalDetail />,
  },
  {
    key: "finance-top-up-return",
    path: "/finance/top-up/return",
    component: <FinanceTopUpReturn />,
  },
  {
    key: "legacy-finance",
    path: "/profile/wallet",
    component: <Navigate to="/finance" replace />,
  },
  {
    key: "withdrawal",
    path: "/profile/withdrawals",
    component: <Navigate to="/finance/withdrawals" replace />,
  },
  {
    key: "accountsettings",
    path: "/account-settings",
    component: <AccountSettings />,
  },
  {
    key: "delete-account",
    path: "/account-settings/delete-account",
    component: <DeleteUser />,
  },
  {
    key: "withdrawal-accounts",
    path: "/withdrawal-accounts",
    component: <Navigate to="/finance/withdraw" replace />,
  },
  {
    key: "saved-accounts",
    path: "/saved-accounts",
    component: <SavedAccounts />,
  },
  {
    key: "myreviews",
    path: "/my-reviews",
    component: <MyReviews />,
  },
  {
    key: "saved-suppliers",
    path: "/saved-suppliers",
    component: <SavedSuppliers />,
  },
  {
    key: "faqs",
    path: "/faqs",
    component: <Faqs />,
  },

  // Sayagie session + OTP auth — now the only way in. /login above
  // redirects here.
  {
    key: "auth-get-started",
    path: "/auth",
    component: (
      <AuthStep step="start">
        <GetStarted />
      </AuthStep>
    ),
  },
  {
    key: "auth-verify",
    path: "/auth/verify",
    component: (
      <AuthStep step="verify">
        <VerificationRoute />
      </AuthStep>
    ),
  },
  {
    key: "auth-details",
    path: "/auth/details",
    component: (
      <AuthStep step="details">
        <AuthSignUp />
      </AuthStep>
    ),
  },
  {
    key: "auth-photo",
    path: "/auth/photo",
    component: (
      <AuthStep step="photo">
        <AddPhoto />
      </AuthStep>
    ),
  },
];
